import React, { useState, useEffect } from 'react';
import "./AdImage.scss";

// BANNERS 728X90
import banner1 from "../../assets/images/banners-728x90/banner1.png"; // https://www.google.com
import banner2 from "../../assets/images/banners-728x90/banner2.png"; // https://www.google.com
import banner3 from "../../assets/images/banners-728x90/banner3.png"; // https://www.google.com
import banner4 from "../../assets/images/banners-728x90/banner4.png"; // https://www.google.com
import banner5 from "../../assets/images/banners-728x90/banner5.png"; // https://www.google.com
import banner6 from "../../assets/images/banners-728x90/banner6.png"; // https://www.google.com
import banner7 from "../../assets/images/banners-728x90/banner7.png"; // https://www.google.com

// BANNERS 300X250
import banner300x250_1 from "../../assets/images/banners-300x250/1.jpg"; // https://www.google.com
import banner300x250_2 from "../../assets/images/banners-300x250/2.jpg"; // https://www.google.com
import banner300x250_3 from "../../assets/images/banners-300x250/3.jpg"; // https://www.google.com

// BANNERS 300X600
import banner300x600_1 from "../../assets/images/banners-300x600/1.gif"; // https://www.google.com

const AdImage = ({ width, height, img }) => {

    const [randomNum, setRandomNum] = useState((Math.floor(Math.random() * 7)));
    const [randomNum2, setRandomNum2] = useState((Math.floor(Math.random() * 3)));
    const [randomNum3, setRandomNum3] = useState((Math.floor(Math.random() * 1)));

    // BANNERS 728X90
    const arrImage = [
        { img: banner1, href: "https://www.google.com", title: "Google" },
        { img: banner2, href: "https://www.google.com", title: "Google" },
        { img: banner3, href: "https://www.google.com", title: "Google" },
        { img: banner4, href: "https://www.google.com", title: "Google" },
        { img: banner5, href: "https://www.google.com", title: "Google" },
        { img: banner6, href: "https://www.google.com", title: "Google" },
        { img: banner7, href: "https://www.google.com", title: "Google" }
    ];

    // BANNERS 300X250
    const arrImage2 = [
        { img: banner300x250_1, href: "https://www.google.com", title: "Google" },
        { img: banner300x250_2, href: "https://www.google.com", title: "Google" },
        { img: banner300x250_3, href: "https://www.google.com", title: "Google" },
    ];

    // BANNERS 300X600
    const arrImage3 = [
        { img: banner300x600_1, href: "https://www.google.com", title: "Google" },
    ];

    useEffect(() => {

        const interval = setInterval(() => {
            setRandomNum((Math.floor(Math.random() * 7)));
            setRandomNum2((Math.floor(Math.random() * 3)));
            setRandomNum3((Math.floor(Math.random() * 1)));
        }, 2000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <>
            {
                width === "728px" && (
                    <a className="ad-image" href={arrImage[randomNum].href} target="_blank" rel="noreferrer" style={{ width: `${width}`, height: `${height}`, maxWidth: "80%" }}>
                        <img src={arrImage[randomNum].img} alt={arrImage[randomNum].title} />
                    </a>
                )
            }

            {
                width === "300px" && height === "250px" && (
                    <a className="ad-image" href={arrImage2[randomNum2].href} target="_blank" rel="noreferrer" style={{ width: `${width}`, height: `${height}` }}>
                        <img src={arrImage2[randomNum2].img} alt={arrImage2[randomNum2].title} />
                    </a>
                )
            }

            {
                width === "300px" && height === "600px" && (
                    <a className="ad-image" href={arrImage3[randomNum3].href} target="_blank" rel="noreferrer" style={{ width: `${width}`, height: `${height}` }}>
                        <img src={arrImage3[randomNum3].img} alt={arrImage3[randomNum3].title} />
                    </a>
                )
            }
        </>
    )
}

export default AdImage;
